import PropTypes from 'prop-types';
// @mui
import { Box, Stack, Typography } from '@mui/material';
//
import { UNIVERSE_FONT } from 'src/theme/universe/brand';

// ---------------------------------------------------------------------------
// THE HEADER OF A LIST, FORM OR SETTINGS PAGE (DESIGN.md §12): the page title
// (28px, 24 on a phone), one meta line — a count, the scope — and the page's
// one primary action at the right. No crumbs, no banner, no tile: the
// navigation is the hierarchy, the header is one row.
// ---------------------------------------------------------------------------

PageHeader.propTypes = {
  title: PropTypes.node.isRequired,
  meta: PropTypes.node,
  action: PropTypes.node,
  secondaryActions: PropTypes.node,
  /**
   * What the page is OF, drawn before the title and centred on the title and
   * its meta line — a board's department glyph. Optional; without it the
   * header is the title and its line, as on every list.
   */
  leading: PropTypes.node,
  sx: PropTypes.object
};

export default function PageHeader({
  title,
  meta,
  action,
  secondaryActions,
  leading,
  sx
}) {
  const heading = (
    <>
      <Typography
        component="h1"
        sx={{
          fontFamily: UNIVERSE_FONT,
          fontWeight: 700,
          fontSize: { xs: 24, sm: 28 },
          lineHeight: 1.2,
          letterSpacing: '-0.01em',
          color: 'text.primary'
        }}
      >
        {title}
      </Typography>
      {meta && (
        <Typography
          component="div"
          sx={{
            mt: 0.5,
            fontFamily: UNIVERSE_FONT,
            fontSize: 12,
            fontWeight: 500,
            lineHeight: 1.4,
            color: 'text.secondary'
          }}
        >
          {meta}
        </Typography>
      )}
    </>
  );
  return (
    <Box
      sx={{
        mb: 3,
        display: 'flex',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        gap: 2,
        ...sx
      }}
    >
      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        {leading ? (
          <Stack
            direction="row"
            alignItems="center"
            spacing={{ xs: 1.5, sm: 1.75 }}
            sx={{ minWidth: 0 }}
          >
            <Box sx={{ flex: 'none', display: 'flex' }}>{leading}</Box>
            <Box sx={{ minWidth: 0 }}>{heading}</Box>
          </Stack>
        ) : (
          heading
        )}
      </Box>
      {(action || secondaryActions) && (
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{ flexShrink: 0, maxWidth: 1 }}
        >
          {secondaryActions}
          {action}
        </Stack>
      )}
    </Box>
  );
}
